import { Pipe, PipeTransform } from '@angular/core';
import Utils from '../utils/utils';

@Pipe({ name: 'hqDate' })
export class HqDatePipe implements PipeTransform {

  transform(val: any): any {
    return Utils.utc2HQDate(val);
  }

}
